export const isIosStandalone = () => {
    const ua = window.navigator.userAgent;

    // Check if it's an Apple touch device
    // iPadOS 13+ reports MacIntel but has maxTouchPoints > 1
    const isAppleDevice =
        /iphone|ipad|ipod/i.test(ua) ||
        (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

    if (!isAppleDevice) return false;

    // iPadOS 26+: navigator.standalone works correctly
    if (window.navigator.standalone === true) return true;

    // iPadOS 18 fallback: navigator.standalone is undefined even in standalone mode
    // Use display-mode media query as the reliable alternative
    if (window.matchMedia("(display-mode: standalone)").matches) return true;

    // Additional fallback: check if launched without browser UI
    if (window.matchMedia("(display-mode: fullscreen)").matches) return true;

    return false;
};

export const setStoredTokens = ({ accessToken, refreshToken }) => {
    if (accessToken) localStorage.setItem("_at", accessToken);
    if (refreshToken) localStorage.setItem("_rt", refreshToken);
};

export const clearStoredTokens = () => {
    localStorage.removeItem("_at");
    localStorage.removeItem("_rt");
};


// True when running against a different host/IP (e.g. iPad → 192.168.1.x)
export const isCrossOrigin = () =>
    window.location.hostname !== new URL(
        process.env.REACT_APP_API_URL || "http://localhost:3002"
    ).hostname;

// Use localStorage token strategy when either condition is true
export const useTokenStorage = () => isIosStandalone() || isCrossOrigin();